import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";
import toast from "react-hot-toast";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Tag } from "../../lib/types";

type Props = {
  tagIds: number[];
  illustrationId: string;
  onUpdate: () => void;
};

export const TagList = ({ tagIds, illustrationId, onUpdate }: Props) => {
  const [tags, setTags] = useState<Tag[]>([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const allTags = await apiClient.get("/tags") as Tag[];
        setTags(allTags.filter((t) => tagIds.includes(t.id)));
      } catch (error) {
        toast.error("タグの取得に失敗しました");
      }
    };

    if (tagIds && tagIds.length > 0) {
      fetchTags();
    } else {
      setTags([]);
    }
  }, [tagIds]);

  const handleDeleteTag = async (tagId: number) => {
    const newTagIds = tagIds.filter((id) => id !== tagId);

    try {
      // イラストのタグ情報を更新するために PATCH /illustrations/:id を使用
      // 既存の他のフィールド（title, categoryなど）を維持するために、まず一件取得してから更新が望ましいが、
      // ここではタグのみの更新を想定（サーバー側で部分更新できれば良いが、現在は全書き換え）

      const illustration = await apiClient.get(`/illustrations/${illustrationId}`);

      await apiClient.patch(`/illustrations/${illustrationId}`, {
        ...illustration,
        tag_ids: newTagIds
      });

      setTags(tags.filter((tag) => tag.id !== tagId));
      onUpdate();
    } catch (error) {
      console.error(error);
      toast.error("タグの削除に失敗しました");
    }
  };

  if (!tags.length) return null;

  return (
    <div className="flex gap-1 flex-wrap">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="px-2 py-1 bg-white text-xs rounded-full border border-gray-300 text-gray-600 flex items-center gap-1"
        >
          {tag.tag}
          <button
            onClick={() => handleDeleteTag(tag.id)}
            className="hover:text-red-500 transition-colors"
          >
            <XMarkIcon className="w-3 h-3" />
          </button>
        </span>
      ))}
    </div>
  );
};
